export default __webpack_public_path__ + "workspace_metatag.png?0c18f4958bc885ac753584e716058dd8";